import { FetchResponse } from '../common/models/app/fetch-response.model';

const RequestTypes = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
};

export class FetchService {
    public get<T>(endpoint: string): Promise<FetchResponse<T>> {
        return new Promise<FetchResponse<T>>((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(RequestTypes.GET, endpoint, true);
            xhr.onload = () => {
                if (xhr.readyState === 4) {
                    const status = xhr.status;
                    if (status === 200) {
                        resolve({
                            data: xhr.responseText ? (JSON.parse(xhr.responseText) as T) : null,
                            ok: true,
                            statusText: xhr.statusText,
                            status
                        } as FetchResponse<T>);
                    } else {
                        resolve({
                            data: null,
                            ok: false,
                            statusText: xhr.statusText,
                            status
                        } as FetchResponse<T>);
                    }
                }
            }

            xhr.onerror = () => {
                reject(new Error(`Post failed to ${endpoint} with status: ${xhr.statusText}`));
            }

            xhr.send(null);
        });
    }

    public post<T>(endpoint: string, data: any, contentType = 'application/json'): Promise<FetchResponse<T>> {
        return new Promise<FetchResponse<T>>((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(RequestTypes.POST, endpoint, true);

            xhr.setRequestHeader("Content-Type", contentType);

            xhr.onload = () => {
                if (xhr.readyState === 4) {
                    const status = xhr.status;
                    if (status === 200 || status === 201 || status === 204) {
                        resolve({
                            data: xhr.responseText ? (JSON.parse(xhr.responseText) as T) : null,
                            ok: true,
                            statusText: xhr.statusText,
                            status
                        } as FetchResponse<T>);
                    } else {
                        resolve({
                            data: null,
                            ok: false,
                            statusText: xhr.statusText,
                            status
                        } as FetchResponse<T>);
                    }
                }
            }

            xhr.onerror = () => {
                reject(new Error(`Post failed to ${endpoint} with status: ${xhr.statusText}`));
            }

            // if content type is json, stringify the payload automatically
            // otherwise, just pass through what was provided
            if (data) {
                xhr.send(contentType == 'application/json' ? JSON.stringify(data) : data);
            } else {
                // send without a data body
                xhr.send();
            }
        });
    }

    public delete<T>(endpoint: string): Promise<FetchResponse<T>> {
        return new Promise<FetchResponse<T>>((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(RequestTypes.DELETE, endpoint, true);

            xhr.onload = () => {
                if (xhr.readyState === 4) {
                    const status = xhr.status;
                    if (status === 204 || status === 200) {
                        let data: T | null = null;
                        if (xhr.responseText) {
                            try {
                                data = JSON.parse(xhr.responseText) as T;
                            } catch {
                                data = null;
                            }
                        }
                        resolve({
                            data,
                            ok: true,
                            statusText: xhr.statusText,
                            status
                        } as FetchResponse<T>);
                    } else {
                        resolve({
                            data: null,
                            ok: false,
                            statusText: xhr.statusText,
                            status
                        } as FetchResponse<T>);
                    }
                }
            };

            xhr.onerror = () => {
                reject(new Error(`Delete failed to ${endpoint} with status: ${xhr.statusText}`));
            };

            xhr.send(null);
        });
    }
}
